
export enum AppChannelMessages {
    APP_READY_MESSAGE = "APP_READY",
    TARGET_ORIGIN_MESSAGE = "TARGET_ORIGIN"
}

export { log, LogOptions, Logger } from "./log"
export { setLogUrl, setLogFlushInterval } from './logShipping'
